import request from '@/utils/request'
import { urlEncode } from '@/utils/urls'
// 支付API类
class PaymentAPI {
  // 创建微信支付订单
  static createWxOrder (productsId) {
    return request({
      url: '/api/v1/payV2/wx/create-order-vo',
      method: 'POST',
      data: productsId
    })
  }

  // 查询商品列表
  static queryroducts () {
    return request({
      url: '/api/v2/products',
      method: 'GET',
      params: {}
    })
  }

  // 查询订单状态
  static queryOrderStatus (orderNumber) {
    return request({
      url: '/api/v1/payV2/query-order-status',
      method: 'GET',
      params: {
        orderNumber
      }
    })
  }

  // 查询订单列表
  static queryOrderList (reqDeps) {
    return request({
      url: '/api/v1/orderV2?' + urlEncode(reqDeps),
      method: 'GET'
    })
  }

  // 查询微信支付状态
  static queryWxPaymentStatus (orderCode) {
    return request({
      url: `/api/v1/payV2/wx/${orderCode}`,
      method: 'GET'
    })
  }
}

export default PaymentAPI
